import React from "react";
import { Link } from "react-router-dom";
import AgendaData27 from "../data/AgendaData27";
import { slugify } from "../utils/slugify";

const SessionListItems = ({ items }) => {
  return (
    <ul className="expert-list">
      {items.map((item, index) => (
        <li key={index}>
          <Link to={`/agenda#${slugify(item)}`}>
            <h2>{item}</h2>
          </Link>
        </li>
      ))}
    </ul>
  );
};

const SessionListContainer = ({ CertifiedLearning }) => {
  const midIndex = Math.ceil(CertifiedLearning.length / 2);
  const firstHalf = CertifiedLearning.slice(0, midIndex);
  const secondHalf = CertifiedLearning.slice(midIndex);

  return (
    <section className="bg-purple">
      <div className="container">
        <div className="row text-center pb-5">
          <div className="col">
            <h1 className="color-white">Certified learning</h1>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 mb-4">
            <SessionListItems items={firstHalf} />
            <SessionListItems items={secondHalf} />
          </div>

          <Link to="/agenda#post-conference-workshop">
            <div className="row">
              <div className="col">
                <div className="bg-sunny-top-right bg-rounded p-5 mb-5">
                  <strong className="color-yellow d-block mb-2">
                    New! Post-conference Workshop
                  </strong>

                  <h2 className="color-white mb-4">
                    Educating Stakeholders at Every Level: How to Successfully
                    Roll Out Your Salary Administration Program
                  </h2>

                  <p className="color-white mb-0">
                    Stay an extra half day at FinComp and walk away with two
                    ready-to-use presentations, a step-by-step rollout plan, and
                    lunch on us. Space is limited for this hands-on add-on.
                  </p>
                </div>
              </div>
            </div>
          </Link>

          <div className="row">
            <div className="col text-center">
              <Link to="/agenda" className="btn-white-o">
                View full Agenda <i className="fa fa-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default function SessionListImporter() {
  const excludedTitles = [
    "Breakfast",
    "Lunch (Workshop Participants Only)",
    "FinComp Registration",
    "TBA",
    "Morning Break",
    "Afternoon Break",
    "HR Roundtables",
    "Breakfast & Registration",
    "Lunch",
    "Networking Mixer",
    "Networking Event",
    "Closing Remarks",
  ];

  const additionalTitles = [];

  const eventTitles = AgendaData27.flatMap((day) =>
    day.events.flatMap((event) => {
      const titles = [];

      if (event.title && !excludedTitles.includes(event.title)) {
        titles.push(event.title);
      }

      if (Array.isArray(event.sessions)) {
        event.sessions.forEach((session) => {
          if (session.title && !excludedTitles.includes(session.title)) {
            titles.push(session.title);
          }
        });
      }

      return titles;
    }),
  );

  const combinedTitles = [...new Set([...eventTitles, ...additionalTitles])];

  return <SessionListContainer CertifiedLearning={combinedTitles} />;
}
